import { NgModule } from "@angular/core";
import { Ng2StateDeclaration, UIRouterModule } from "@uirouter/angular";
import { ExampleWhiteboardsComponent } from "@webapp/examples/example-whiteboards/example-whiteboards.component";
import { ExampleButtonsComponent } from "@webapp/examples/example-buttons/example-buttons.component";
import { ExampleIconsComponent } from "@webapp/examples/example-icons/example-icons.component";
import { ExampleModalComponent } from "@webapp/examples/example-modals/example-modal.component";
import { ExampleDividerComponent } from "@webapp/examples/example-divider/example-divider.component";
import { ExamplePopoverComponent } from "@webapp/examples/example-popover/example-popover.component";
import { ExampleSpinComponent } from "@webapp/examples/example-spin/example-spin.component";
import { ExamplePermissionsComponent } from "@webapp/examples/example-permissions/example-permissions.component";
import { ExampleMenuComponent } from "@webapp/examples/example-menu/example-menu.component";
import { ExampleSelectComponent } from "@webapp/examples/example-select/example-select.component";
import { ExampleGridComponent } from "@webapp/examples/example-grid/example-grid.component";
import { ExampleDrawerComponent } from "@webapp/examples/example-drawer/example-drawer.component";
import { ExampleFormComponent } from "@webapp/examples/example-form/example-form.component";
import { ExampleColorsComponent } from "@webapp/examples/example-colors/example-colors.component";
import { ExampleSkeletonComponent } from "@webapp/examples/example-skeleton/example-skeleton.component";
import { ExampleToggleComponent } from "@webapp/examples/example-toggle/example-toggle.component";
import { ExampleCheckboxComponent } from "@webapp/examples/example-checkbox/example-checkbox.component";
import { ExamplesComponent } from "@webapp/examples/examples.component";
import { ExampleAvatarsComponent } from "@webapp/examples/example-avatars/example-avatars.component";
import { ExampleInputComponent } from "@webapp/examples/example-input/example-input.component";
import { ExampleRadioButtonsComponent } from "@webapp/examples/example-radio-buttons/example-radio-buttons.component";
import { ExampleAlertsComponent } from "@webapp/examples/example-alerts/example-alerts.component";
import { ExampleNotificationsComponent } from "@webapp/examples/example-notifications/example-notifications.component";
import { ExampleMentionsComponent } from "@webapp/examples/example-mentions/example-mentions.component";
import { ExampleCardComponent } from "@webapp/examples/example-card/example-card.component";
import { ExampleMessagesComponent } from "@webapp/examples/example-messages/example-messages.component";
import { ExampleTabComponent } from "@webapp/examples/example-tab/example-tab.component";
import { ExampleTagComponent } from "@webapp/examples/example-tag/example-tag.component";
import { ExampleCollapseComponent } from "@webapp/examples/example-collapse/example-collapse.component";
import { ExampleDropdownComponent } from "@webapp/examples/example-dropdown/example-dropdown.component";
import { ExampleTooltipComponent } from "@webapp/examples/example-tooltip/example-tooltip.component";
import { ExampleEmptyComponent } from "@webapp/examples/example-empty/example-empty.component";
import { ExampleBadgeComponent } from "@webapp/examples/example-badge/example-badge";
import { ExampleListComponent } from "@webapp/examples/example-list/example-list.component";

const exampleHome: Ng2StateDeclaration = {
  name: "gh.examples.home",
  url: "/home",
  component: ExamplesComponent,
};
const exampleStateWhiteboard: Ng2StateDeclaration = {
  name: "gh.examples.whiteboards",
  url: "/whiteboards",
  component: ExampleWhiteboardsComponent,
};
const exampleAlerts: Ng2StateDeclaration = {
  name: "gh.examples.alerts",
  url: "/alerts",
  component: ExampleAlertsComponent,
};
const exampleButtons: Ng2StateDeclaration = {
  name: "gh.examples.buttons",
  url: "/buttons",
  component: ExampleButtonsComponent,
};
const exampleTooltip: Ng2StateDeclaration = {
  name: "gh.examples.tooltip",
  url: "/tooltip",
  component: ExampleTooltipComponent,
};
const exampleInput: Ng2StateDeclaration = {
  name: "gh.examples.input",
  url: "/input",
  component: ExampleInputComponent,
};
const exampleGrid: Ng2StateDeclaration = {
  name: "gh.examples.grid",
  url: "/grid",
  component: ExampleGridComponent,
};
const exampleAvatars: Ng2StateDeclaration = {
  name: "gh.examples.avatar",
  url: "/avatar",
  component: ExampleAvatarsComponent,
};
const exampleEmpty: Ng2StateDeclaration = {
  name: "gh.examples.empty",
  url: "/empty",
  component: ExampleEmptyComponent,
};
const exampleSelect: Ng2StateDeclaration = {
  name: "gh.examples.select",
  url: "/select",
  component: ExampleSelectComponent,
};
const exampleToggle: Ng2StateDeclaration = {
  name: "gh.examples.toggle",
  url: "/toggle",
  component: ExampleToggleComponent,
};
const exampleDrawers: Ng2StateDeclaration = {
  name: "gh.examples.drawers",
  url: "/drawers",
  component: ExampleDrawerComponent,
};
const exampleModals: Ng2StateDeclaration = {
  name: "gh.examples.modals",
  url: "/modals",
  component: ExampleModalComponent,
};
const exampleBadge: Ng2StateDeclaration = {
  name: "gh.examples.badge",
  url: "/badge",
  component: ExampleBadgeComponent,
};
const examplePopover: Ng2StateDeclaration = {
  name: "gh.examples.popovers",
  url: "/popovers",
  component: ExamplePopoverComponent,
};
const exampleIcons: Ng2StateDeclaration = {
  name: "gh.examples.icons",
  url: "/icons",
  component: ExampleIconsComponent,
};
const exampleColors: Ng2StateDeclaration = {
  name: "gh.examples.colors",
  url: "/colors",
  component: ExampleColorsComponent,
};
const exampleDivider: Ng2StateDeclaration = {
  name: "gh.examples.divider",
  url: "/divider",
  component: ExampleDividerComponent,
};
const exampleMessages: Ng2StateDeclaration = {
  name: "gh.examples.messages",
  url: "/messages",
  component: ExampleMessagesComponent,
};
const exampleSkeleton: Ng2StateDeclaration = {
  name: "gh.examples.skeleton",
  url: "/skeleton",
  component: ExampleSkeletonComponent,
};

const exampleCollapse: Ng2StateDeclaration = {
  name: "gh.examples.collapse",
  url: "/collapse",
  component: ExampleCollapseComponent,
};
const examplePermissions: Ng2StateDeclaration = {
  name: "gh.examples.permissions",
  url: "/permissions",
  component: ExamplePermissionsComponent,
};
const exampleCard: Ng2StateDeclaration = {
  name: "gh.examples.card",
  url: "/card",
  component: ExampleCardComponent,
};
const exampleRadioButtons: Ng2StateDeclaration = {
  name: "gh.examples.radio",
  url: "/radio-buttons",
  component: ExampleRadioButtonsComponent,
};

const exampleNotifications: Ng2StateDeclaration = {
  name: "gh.examples.notifications",
  url: "/notifications",
  component: ExampleNotificationsComponent,
};

const exampleList: Ng2StateDeclaration = {
  name: "gh.examples.list",
  url: "/list",
  component: ExampleListComponent,
};

const exampleMenu: Ng2StateDeclaration = {
  name: "gh.examples.menu",
  url: "/menu",
  component: ExampleMenuComponent,
};

const exampleCheckbox: Ng2StateDeclaration = {
  name: "gh.examples.checkbox",
  url: "/checkbox",
  component: ExampleCheckboxComponent,
};
const exampleMentions: Ng2StateDeclaration = {
  name: "gh.examples.mentions",
  url: "/mentions",
  component: ExampleMentionsComponent,
};

const exampleTab: Ng2StateDeclaration = {
  name: "gh.examples.tab",
  url: "/tab",
  component: ExampleTabComponent,
};

const exampleTag: Ng2StateDeclaration = {
  name: "gh.examples.tag",
  url: "/tag",
  component: ExampleTagComponent,
};

const exampleSpin: Ng2StateDeclaration = {
  name: "gh.examples.spin",
  url: "/spin",
  component: ExampleSpinComponent,
};
const exampleForm: Ng2StateDeclaration = {
  name: "gh.examples.form",
  url: "/form",
  component: ExampleFormComponent,
};
const exampleDropdown: Ng2StateDeclaration = {
  name: "gh.examples.dropdown",
  url: "/dropdown",
  component: ExampleDropdownComponent,
};

const routes = [
  exampleHome,
  exampleList,
  exampleMenu,
  examplePermissions,
  exampleAvatars,
  examplePopover,
  exampleRadioButtons,
  exampleAlerts,
  exampleTab,
  exampleTag,
  exampleTooltip,
  exampleModals,
  exampleBadge,
  exampleMentions,
  exampleEmpty,
  exampleDrawers,
  exampleCard,
  exampleIcons,
  exampleSkeleton,
  exampleColors,
  exampleButtons,
  exampleStateWhiteboard,
  exampleDivider,
  exampleCollapse,
  exampleSpin,
  exampleInput,
  exampleCheckbox,
  exampleSelect,
  exampleToggle,
  exampleGrid,
  exampleNotifications,
  exampleForm,
  exampleMessages,
  exampleDropdown,
];

@NgModule({
  imports: [UIRouterModule.forChild({ states: routes })],
  exports: [UIRouterModule],
})
export class ExamplesRoutingModule {}
